import React from "react";
import styles from "./TranslateLoader.module.css";

export const TranslateLoader: React.FC<{
  isLoading: boolean;
}> = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }
  return (
    <div className={styles.loader}>
      <span className="notranslate">translating</span>
      <svg
        className={styles.animation}
        width="56"
        height="8"
        viewBox="0 0 56 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className={styles.pulse}
          cx="52"
          cy="4"
          r="4"
          fill="url(#paint0_linear_2395_1914)"
        />
        <circle
          className={styles.pulse}
          cx="36"
          cy="4"
          r="4"
          fill="url(#paint1_linear_2395_1914)"
        />
        <circle
          className={styles.pulse}
          cx="20"
          cy="4"
          r="4"
          fill="url(#paint2_linear_2395_1914)"
        />
        <circle
          className={styles.pulse}
          cx="4"
          cy="4"
          r="4"
          fill="url(#paint3_linear_2395_1914)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2395_1914"
            x1="2.25"
            y1="48.5"
            x2="5.75"
            y2="55.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF9B3F" />
            <stop offset="1" stopColor="#E21F26" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2395_1914"
            x1="2.25"
            y1="32.5"
            x2="5.75"
            y2="39.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0CF7E8" />
            <stop offset="1" stopColor="#19B4E9" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2395_1914"
            x1="2.25"
            y1="16.5"
            x2="5.75"
            y2="23.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD705" />
            <stop offset="1" stopColor="#F78E20" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2395_1914"
            x1="2.25"
            y1="0.5"
            x2="5.75"
            y2="7.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E1E424" />
            <stop offset="1" stopColor="#8EC640" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
